import styled from 'styled-components';

import { LANDING_BREAKPOINT } from '@utils/theme/breakPoint';

export const StyledCampaignCard = styled.div<{
  icon: string;
  width: string;
  isBlurry: boolean;
}>`
  position: relative;
  background: url(${(props) => props.icon}) no-repeat center;
  height: 358px;
  width: ${(props) => props.width};
  background-size: cover;
  margin: 0 10px;
  opacity: ${(props) => (props.isBlurry ? 0.3 : 1)};
`;
export const CampaignCardTitle = styled.div<{
  subTitleAvailable: boolean;
}>`
  font-size: 24px;
  color: ${({ theme }) => theme.palette.white};
  padding-left: 20px;
  font-weight: bold;
  padding-bottom: 5px;
  margin-top: ${(props) => (props.subTitleAvailable ? '-7px' : 0)};
  @media (max-width: ${LANDING_BREAKPOINT}) {
    font-size: 14px;
  }
`;

export const CampaignVerticalLine = styled.div`
  width: 6px;
  background: ${({ theme }) => theme.palette.coral};
  height: 36px;
  border-radius: 5px;
  margin-left: 20px;
`;

export const CampaignCardSubTitle = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.white};
  width: 100%;
  line-height: 1.42;
  @media (max-width: ${LANDING_BREAKPOINT}) {
    font-size: 12px;
  }
`;

export const CampaignTitleContainer = styled.div`
  display: flex;
  height: 100px;
`;

export const InfoWrapper = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  height: 150px;
  align-items: flex-end;
  width: 100%;
  background-image: linear-gradient(
    to bottom,
    rgba(108, 108, 108, 0),
    ${({ theme }) => theme.palette.eclipse}
  );
`;

export const CampaignSpecialImg = styled.div<{ img: string }>`
  &:before {
    background-image: url(${(props) => props.img});
    content: '';
    width: 50px;
    height: 50px;
    left: 46px;
    top: 55%;
    @media (max-width: ${LANDING_BREAKPOINT}) {
      top: 20%;
    }
    position: absolute;
    background-size: cover;
  }
`;

export const CampaignImgWrapper = styled.div`
  position: relative;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
`;
